module.exports = __webpack_public_path__ + "static/black_dog-0379b4b6d245254e07b9cebc120d1683.jpg";